import * as React from 'react';
import { useFeatureFlagWithStatus } from '../../../../shared/featureFlags/useFeatureFlagWithStatus';
import { FeatureFlagKeys } from '../../../../shared/featureFlags/featureFlagKeys';
import OrdersPageV1 from './v1/OrdersPage';
import OrdersPageV2 from './v2/OrdersPage';
import ListSkeleton from './v2/components/ListSkeleton';

function BrokerAgentsOrderPageDelegate() {
    let { value: isBrokerAgentOrderListV2Enabled, isLoading } = useFeatureFlagWithStatus(
        FeatureFlagKeys.BrokerAgentOrderListV2,
        false
    );

    if (isLoading) {
        return <ListSkeleton />;
    }

    if (isBrokerAgentOrderListV2Enabled) {
        return <OrdersPageV2 />;
    }

    return <OrdersPageV1 />;
}

export default BrokerAgentsOrderPageDelegate;
